module.exports = __webpack_public_path__ + "img/144.977cfbea.png";